import type { AccountPlaDto } from '../../../types/api';

export interface EnabledAssessmentOption {
  value: string;
  label: string;
}

/**
 * Assessments enabled for the account: configured in the PLA list and neither suspended nor
 * deleted. Labels prefer the bundled assessment content's dName (same rule as AggReportSetupView).
 */
export function getEnabledAssessmentOptions(
  plaList: AccountPlaDto[],
  assessments: Array<{ sourceId?: string; dName?: string }>
): EnabledAssessmentOption[] {
  const seen = new Set<string>();
  const result: EnabledAssessmentOption[] = [];
  plaList.forEach((pla) => {
    const assessmentId = (pla.AssessmentId || '').trim();
    if (!assessmentId || seen.has(assessmentId)) {
      return;
    }
    if (pla.Suspended === '1' || pla.Status === '-1') {
      return;
    }
    seen.add(assessmentId);
    const content = assessments.find((a) => a.sourceId === assessmentId);
    result.push({ value: assessmentId, label: content?.dName || pla.DName || assessmentId });
  });
  return result;
}
